import React, { useEffect, useState, useRef } from 'react';
import { FaHeart } from 'react-icons/fa';
import ProgressiveImage from './ProgressiveImage';
import './Hero.css';

const Hero = ({ isNavbarVisible }) => {
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        const maxOffset = Math.max(0, rect.width * 0.7 - rect.height);
        
        const scrollProgress = Math.max(0, -rect.top);
        const parallaxSpeed = 0.5;
        const parallaxOffset = Math.min(scrollProgress * parallaxSpeed, maxOffset);

        setScrollY(-parallaxOffset);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <section id="home" className={`hero ${isNavbarVisible ? 'navbar-visible' : ''}`} ref={heroRef}>
      <ProgressiveImage
        asBackground
        src={`${process.env.PUBLIC_URL}/images/collage.avif`}
        placeholder={`${process.env.PUBLIC_URL}/images/collage-low-res.avif`}
        className="hero-background"
        style={{
          transform: `translateY(${scrollY}px)`
        }}
      >
        <div className="hero-overlay"></div>
      </ProgressiveImage>
      
      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <h1 className="hero-title">
              Sonty & Gavin
            </h1>
            <div className="hero-subtitle">
              <FaHeart className="heart-icon" />
              <span>are getting married</span>
              <FaHeart className="heart-icon" />
            </div>
            <p className="hero-date">January 16, 2027</p>
            <p className="hero-location">@ The Surin<br/>Phuket, Thailand</p>
            <div className="hero-buttons">
              {/* <button 
                className="btn"
                onClick={() => document.getElementById('rsvp').scrollIntoView({ behavior: 'smooth' })}
              >
                RSVP Now
              </button> */}
            </div>
          </div>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;
